module.exports = {
      id: "automobile-usage",
      viewBox: "0 0 31.664 23.083",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#automobile",
      toString: function () {
        return this.url;
      }
    }